/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC } from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import Layout from '../../components/Dashboard/newLayout'
import AdminCriteria from './AdminCriteria'
import './styles.scss'

interface Props extends RouteComponentProps {
  setIsAuthenticated: (isAuthenticated: boolean) => void
}

const ContactRecon: FC<Props> = ({ setIsAuthenticated, match, location, history }) => {
  return (
    <Layout title="Contact Recon" setIsAuthenticated={setIsAuthenticated}>
      <div className="main-container">
        <div className="recon-body">
          <AdminCriteria {...{ history, match, location }} />
        </div>
      </div>
    </Layout>
  )
}

export default withRouter(ContactRecon)
